import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { isValidCPF } from './util'

export const validationRules = (entries: string[], messages?: {[key: string]: {[key: string]: string}}) => {
  const { t } = useI18n()
  const result = {}

  entries.map((rule) => {
    const opts = rule.split('|')
    const field = opts.splice(0, 1)[0]

    if (typeof result[field] === 'undefined') result[field] = []

    opts.map((opt) => {
      const params = opt.split(':')
      const ruleName = params.shift()

      switch (ruleName.toLowerCase()) {
        case 'required':
          result[field].push({
            name: 'required',
            test: (value) => {
              if([null, undefined, ''].includes(value)) return false
              else if (typeof value === 'object' && !(value instanceof Date)) return value && Object.values(value).length > 0
              return true
            },
            message: messages?.[field]?.[ruleName] || t('validation.required')
          })
          break
        case 'max':
          result[field].push({
            name: 'maxLength',
            test: (value) => `${value}`.length ? `${value}`.length <= parseInt(params[0]) : true,
            message: messages?.[field]?.[ruleName] || t('validation.max', {max: params[0]})
          })
          break
        case 'min-value':
          result[field].push({
            name: 'minValue',
            test: (value) => `${value}`.length ? `${value}`.length >= parseInt(params[0]) : true,
            message: messages?.[field]?.[ruleName] || t('validation.min', {max: params[0]})
          })
          break
        case 'range':
          result[field].push({
            name: 'range',
            test: (value) => {
              if(!`${value}`.length) return true
              value = parseInt(`${value}`)
              return value >= parseInt(params[0]) && value <= parseInt(params[1])
            } ,
            message: messages?.[field]?.[ruleName] || t('validation.range', [params[0], params[1]])
          })
          break
        case 'basic-characters':
          result[field].push({
            name: 'basic-characters',
            test: (value) => value?.length ? /^[a-z-A-Z-0-9_-]*$/.test(value) : true,
            message: messages?.[field]?.[ruleName] || t('validation.basicCharacters')
          })
          break
        case 'phone':
          result[field].push({
            name: 'phone',
            test: (value) => value?.length ? /^(\+\d{1,3}[- ]?)?\d{10,12}$/.test(value.replace(/^(\+)|\D/g, '$1')) : true,
            message: messages?.[field]?.[ruleName] || t('validation.invalid', {field: t('input.phone').toLowerCase()})
          })
          break
        case 'date':
          result[field].push({
            name: 'date',
            test: (value) => value ? /^\d{4}-\d{1,2}-\d{1,2}$/.test(value) : true,
            message: messages?.[field]?.[ruleName] ||  t('validation.invalid', {field: t('labels.date').toLowerCase()})
          })
          break
        case 'cpf':
          result[field].push({
            name: 'cpf',
            test: (value) => value?.length ? isValidCPF(value) : true,
            message: messages?.[field]?.[ruleName] || t('validation.invalid', {field: t('labels.cpf').toLowerCase()})
          })
          break
        case 'email':
          result[field].push({
            name: 'email',
            test: (value) => value?.length ? /\S+@\S+\.\S+/.test(value) : true,
            message: messages?.[field]?.[ruleName] || t('validation.invalid', {field: t('input.email').toLowerCase()})
          })
          break
        default:
          break
      }
    })
  })

  return reactive(result)
}
